import type { AssistantMessage, ChatMessage, QaBankMessage } from "@/types/ui";
import { createPostMutation, type BaseMutationInput } from "./mutation-factory";
import type { ChatContext } from "@/utils/chat-selection";

interface CreateChatMessageInput extends BaseMutationInput {
  context: ChatContext;
  threadId: string;
  message: string;
  images: string[];
  isNewThread: boolean;
}

export const createChatMessage = createPostMutation<
  CreateChatMessageInput,
  { messages: (AssistantMessage | QaBankMessage)[] }
>(
  (input) => `/chat/threads/${input.threadId}/messages`,
  (input) => ({
    context: input.context,
    message: input.message,
    images: input.images,
    isNewThread: input.isNewThread,
  })
);

interface CreateChatThreadInput extends BaseMutationInput {
  messageHistory: ChatMessage[];
  context: ChatContext;
}

export const createChatThread = createPostMutation<CreateChatThreadInput, { threadId: string }>(
  "/chat/threads",
  (input) => ({
    messageHistory: input.messageHistory,
    context: input.context,
  })
);
